'use strict';exports.__esModule = true;exports.sendFBRemarketingData = exports.sendGoogleRemarketingData = undefined;var _constants = require('../../constants');

var sendGoogleRemarketingData = exports.sendGoogleRemarketingData = function sendGoogleRemarketingData() {var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var price = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var googleTagParams = {
    dynx_itemid: id,
    dynx_pagetype: _constants.remarketing.pageType,
    dynx_totalvalue: price };


  if (global && global.google_trackConversion) {
    global.google_trackConversion({
      google_conversion_id: _constants.remarketing.conversionId,
      google_custom_params: googleTagParams,
      google_remarketing_only: true });

  }
};

var sendFBRemarketingData = exports.sendFBRemarketingData = function sendFBRemarketingData(_ref) {var id = _ref.id,description = _ref.description,city = _ref.city,price = _ref.price;
  if (global && global.fbq) {
    global.fbq('track', 'ViewContent', {
      content_type: 'product',
      content_ids: id,
      content_name: description,
      content_category: city,
      value: price,
      currency: 'ILS' });

  }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/analytics/remarketing.js
// module id = 3086
// module chunks = 0